import { useAuth } from "@/contexts/AuthContext";
import { useNotify } from "@/contexts/NotifyContext";
import { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table";
import axios from "axios";
import { CheckSquare2, GraduationCap, QrCode, UniversityIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "../ui/button";

export function ViewRoles() {
	const navigate = useNavigate();
	const { getRoles, setToken } = useAuth();
	const { notify, setNotify } = useNotify();

	const [roles, setRoles] = useState<any>(null);
	
	useEffect(() => {
		async function fetchRoles() {
			setNotify(null)
			setToken(axios);
			try {
				let response = await getRoles()
				const { roles } = response.data;
				console.log("roles", roles)
				setRoles(roles);
			} catch (error) {
				setNotify({ title: "Roles Failed", error, severity: 'error' });
			}
		}
		if (!roles)
			fetchRoles()
	}, []);

	const formatRoles = (roles: string[]) => {
		const result: any = [];
		const size = "16";
		result.push(roles.indexOf("admin.all") < 0 ? <svg width={size} height={size} /> : <UniversityIcon size={size}/> )
		result.push(roles.indexOf("admin.angkatan") < 0 ? <svg width={size} height={size} /> : <GraduationCap size={size} /> )
		result.push(roles.indexOf("panitia.pindai") < 0 ? <svg width={size} height={size} /> : <QrCode size={size} /> )
		result.push(roles.indexOf("panitia.absensi") < 0 ? <svg width={size} height={size} /> : <CheckSquare2 size={size} /> )
		return <div className="flex flex-row items-center justify-start gap-0.5">{result}</div>;
	}

	const onRowClick = (e: any, item: any) => {
		console.log(item);
		navigate(`edit/${item.UserId}/${item.Email}/${item.Graduation}`)
	}

	function showRoles() {
		let elements: any[] = []
		if (roles) {
			for (let i = 0; i < roles.length; i++) {
				const role = roles[i];
				elements.push(
					<TableRow key={role.UserId} onClick={(e) => onRowClick(e, role)} className="">
						<TableCell className="py-0.5 text-sm">
							<div className="font-semibold">{role.Name} ({role.Graduation})</div>							
							<div className="text-xs">{role.Email}</div>
						</TableCell>
						<TableCell className="py-0.5 text-sm">{formatRoles(role.Roles)}</TableCell>
					</TableRow>)
			}
		}
		return <>{elements}</>
	}

	const onRolesAdd = async () => {
			navigate("add")
	}

	const onRolesClose = async () => {
			navigate(-1)
	}

	return (
		<div className="max-w-120 h-[calc(100vh-180px)] overflow-hidden">
			<div className="sticky top-0 z-20">
				<Table>
					<TableHeader className="bg-(--color-surface)">
						<TableRow>
							<TableHead className="font-bold">Nama, Email</TableHead>
							<TableHead className="font-bold">Roles</TableHead>
						</TableRow>
					</TableHeader>
				</Table>
			</div>
			<div className="h-[calc(100%-90px)] overflow-y-auto">
				<Table>
					<TableBody>
						{showRoles()}
					</TableBody>
				</Table>
			</div>
			<div className="flex flex-row gap-3 items-center justify-center mt-3">
				<Button variant={"default"} onClick={onRolesAdd}>Cari</Button>
				<Button variant={"secondary"} onClick={onRolesClose}>Tutup</Button>
			</div>
		</div>
	)
}